import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { useConfig } from './ConfigContext';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [userServiceUrl, setUserServiceUrl] = useState(null);
    const navigate = useNavigate();
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setUserServiceUrl(config["user_service_url"]);
        }
    }, [config]);

    const handleLogin = async (event) => {
        event.preventDefault();
        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('password', password);

            const response = await fetch(userServiceUrl + '/login', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                const { refresh_token, access_token } = data;
                localStorage.setItem('refresh_token', refresh_token);
                sessionStorage.setItem('access_token', access_token);
                navigate('/admin');
            } else {
                const errorData = await response.json();
                setError(errorData.message);
            }
        } catch (error) {
            setError('An error occurred during login.');
            console.error('Error:', error);
        }
    };

    const navigateToRegister = () => {
        navigate('/register');
    };

    return (
        <div className="login-container">
            <h1>Login</h1>
            <form onSubmit={handleLogin}>
                <div>
                    <label>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Password:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Login</button>
            </form>
            <button onClick={navigateToRegister}>Register</button>
            {error && <div className="error">{error}</div>}
        </div>
    );
};

export default Login;
